var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Voltmeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "tN2NVbCkHpmdDkE~sLp2sa",
    cx: 24,
    cy: 21.087,
    r: 34.957,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 146",
    gradientTransform: "matrix(1 0 0 .96552 0 .207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe9f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#d6e0e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfc8d1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M6,32H42a0,0,0,0,1,0,0v8a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V32A0,0,0,0,1,6,32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tN2NVbCkHpmdDkE~sLp2sa)",
    d: "M8,6H40a2,2,0,0,1,2,2V33a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V8A2,2,0,0,1,8,6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M37.001,19a.99982.99982,0,0,1-.91211-.58789A13.11031,13.11031,0,0,0,24,11a13.11031,13.11031,0,0,0-12.08887,7.41211,1,1,0,1,1-1.82226-.82422A15.11006,15.11006,0,0,1,24,9a15.11006,15.11006,0,0,1,13.91113,8.58789A1,1,0,0,1,37.001,19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M13,21a.99676.99676,0,0,1-.707-.293l-2-2A.99989.99989,0,0,1,11.707,17.293l2,2A1,1,0,0,1,13,21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M18.001,16a.99894.99894,0,0,1-.8584-.48535l-1.5-2.5a1,1,0,1,1,1.71484-1.0293l1.5,2.5A1,1,0,0,1,18.001,16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M29.999,16a1,1,0,0,1-.85644-1.51465l1.5-2.5a1,1,0,1,1,1.71484,1.0293l-1.5,2.5A.99894.99894,0,0,1,29.999,16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M35,21a1,1,0,0,1-.707-1.707l2-2A.99989.99989,0,1,1,37.707,18.707l-2,2A.99676.99676,0,0,1,35,21Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M24,14a.99943.99943,0,0,1-1-1V10a1,1,0,0,1,2,0v3A.99943.99943,0,0,1,24,14Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M24.001,35a.9988.9988,0,0,1-.78223-.375l-8-10a1.00049,1.00049,0,1,1,1.5625-1.25l8,10A.99991.99991,0,0,1,24.001,35Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 36,
    r: 6,
    fill: "#0078d4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,33a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-1a4,4,0,1,0,4,4,4.00452,4.00452,0,0,0-4-4Z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,33a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-.5A3.5,3.5,0,1,0,27.5,36,3.504,3.504,0,0,0,24,32.5Z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 36,
    r: 3,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,37a1,1,0,1,1-1,1,1,1,0,0,1,1-1m0-1a2,2,0,1,0,2,2,2.00228,2.00228,0,0,0-2-2Z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,37a1,1,0,1,1-1,1,1,1,0,0,1,1-1m0-.5A1.5,1.5,0,1,0,11.5,38,1.50172,1.50172,0,0,0,10,36.5Z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 38,
    r: 1,
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38,37a1,1,0,1,1-1,1,1,1,0,0,1,1-1m0-1a2,2,0,1,0,2,2,2.00228,2.00228,0,0,0-2-2Z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,37a1,1,0,1,1-1,1,1,1,0,0,1,1-1m0-.5A1.5,1.5,0,1,0,39.5,38,1.50172,1.50172,0,0,0,38,36.5Z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 1,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Voltmeter);
export default __webpack_public_path__ + "static/media/icons8-voltmeter.d9b4d1a2430fe6a50548a04c777308f0.svg";
export { ForwardRef as ReactComponent };